import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
var PageLayout = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PageLayout, _React$PureComponent);
  var _super = _createSuper(PageLayout);
  function PageLayout() {
    _classCallCheck(this, PageLayout);
    return _super.apply(this, arguments);
  }
  _createClass(PageLayout, [{
    key: "renderContent",
    value: function renderContent() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: "page-layout-content"
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        hero = _this$props.hero,
        subfooter = _this$props.subfooter;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, hero, this.renderContent(), subfooter);
    }
  }]);
  return PageLayout;
}(React.PureComponent);
export { PageLayout as default };
PageLayout.defaultProps = {
  className: '',
  hero: null,
  subfooter: null
};